<h2 mat-dialog-title>Varmistus</h2>
<mat-dialog-content>
  {{context}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial color="warn">Ei</button>
  <button mat-button [mat-dialog-close]="true" color="primary">Kyllä</button>
</mat-dialog-actions>
